import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { resetState as resetPayment } from '../redux/slices/paymentSlice';
import { resetState as resetLandSearch } from '../redux/slices/landSearchSlice';

class RouteStateResetter extends React.Component {
  componentDidMount() {
    //this.handleResetIfNeeded();
    this.lastPath = this.props.location.pathname;
  }

  /*componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.handleResetIfNeeded();
    }
  }*/


  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location;

    // If the pathname changed
    if (pathname !== prevProps.location.pathname) {
      this.handleReset(); // always reset on path change
      this.lastPath = pathname;
    }
  }

  /*handleResetIfNeeded = () => {
    const { pathname } = this.props.location;
    const { resetPayment, resetLandSearch } = this.props;

    const shouldReset = ['/home', '/about', '/contact', '/'].includes(pathname);

    if (shouldReset) {
      resetPayment();
      resetLandSearch();
    }
  };*/

  handleReset = () => {
    const { resetPayment, resetLandSearch } = this.props;
    resetPayment();
    resetLandSearch();
  };

  render() {
    return this.props.children;
  }
}

const mapDispatchToProps = {
  resetPayment,
  resetLandSearch,
};

export default withRouter(connect(null, mapDispatchToProps)(RouteStateResetter));
